import { Box, makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ParcelList from "./ParcelList";

const useStyles = makeStyles((theme) => ({
    container: {
        overflow: 'scroll',
        marginTop: 20,
        paddingRight: 20,
        width: '100%',
        overflowX: 'hidden'
    },
    titleStyle: {
        color: '#FBFBFB',
        opacity: 0.7,
        marginLeft: 20
    }
}));

function PickupListSection() {
    const classes = useStyles();
    const { t } = useTranslation('selfPickup');

    const scrollStyle = { height: 'calc(100vh - 222px)' };

    const validOrders = useSelector(state => state.selfPickupReducer.validOrders);

    const [resList, setResList] = useState(validOrders);

    useEffect(() => {
        setResList(validOrders);
    }, [validOrders])

    return (
        <Box className={classes.container} style={scrollStyle}>
            <div className={classes.titleStyle}>{t('search_results')}</div>
            <div className={classes.cardGroupStyle}>
                <ParcelList list={resList} />
            </div>
        </Box>
    )
}

export default PickupListSection;